import { durationFromSeconds } from "./datetime";

/**
 * Formats a timing in seconds to a display string (e.g., "1:23" or "1:23:45")
 * Strips leading "00:" if the duration is less than an hour
 */
export default function formatMentionTiming(seconds?: number): string {
  if (seconds == null) return "";
  const full = durationFromSeconds(seconds);
  if (full.startsWith("00:")) return full.slice(3);
  return full;
}
